/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CloseAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ButtonIcon from 'DesignSystem/ButtonIcon/index'
import Label from 'DesignSystem/Label/index'
import React from 'react'
import Shortcut from 'DesignSystem/Shortcut/react'
import XIcon from 'DesignSystem/Svgs/XIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CloseAction({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Scheduled/Secondary/DiagnosisAction/Content/Diagnosis/Content/CloseAction"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let onPress = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ButtonIcon
  viewPath={`${viewPath}/ButtonIcon`}
 marginLeft="auto"
 paddingTop={dtSpaceXs}
 paddingBottom={dtSpaceXs}
 onClick={onClick}
>
{childProps => (
<div
  data-testid="CloseAction.Vertical"
  data-view-path={viewPath}
 style={{'--w-1-1xAYKG': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--mt-2-1xAYKG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<XIcon
  viewPath={`${viewPath}/XIcon`}
/>
<Label
  viewPath={`${viewPath}/Label`}
 marginTop={dtSpaceXs}
 text="ESC"
/>
<Shortcut
  viewPath={`${viewPath}/Shortcut`}
 keys="esc"
 type="keyup"
 onPress={onPress}
/>
</div>
)}
</ButtonIcon>
{children}
</React.Fragment>)
}